export enum MoveOutRequestStatus {
  Requested = 'requested',
  Rejected = 'rejected',
  Approved = 'approved',
  Retracted = 'retracted',
}

export interface MoveOutRequest {
  id: string;
  leaseId: string;
  status: MoveOutRequestStatus;
  moveOutDate: string;
  reason?: string;
  createdDate: string;
}

export interface CreateMoveOutRequest {
  moveOutDate: string;
  reason?: string;
}
